import _ from 'lodash'
import { useEffect } from 'react'
import { create } from 'zustand'
import * as jose from 'jose'
import useConfig from '@vero/ui-core-browser/hooks/config.js'
import AuthClient from '@vero/api-client-browser/clients/auth.js'
import { completeEmployeeInvitations } from '../utils.js'

let completedEmployeeInvitationsForToken

const useClaimsStore = create(set => ({
  claims: null,
  setClaims: claims => {
    set({ claims })
  }
}))

export default function () {
  const { claims, setClaims } = useClaimsStore()
  const { config } = useConfig()

  const authClient = new AuthClient()

  async function fetchClaims () {
    try {
      const idToken = authClient.tokens?.idToken
      const userPoolProviderUrl = config?.cognito?.userPoolProviderUrl

      if (userPoolProviderUrl && idToken) {
        const { payload } = await jose.jwtVerify(
          idToken,
          jose.createRemoteJWKSet(new URL(`${window.location.origin}/.well-known/jwks.json`)),
          {
            issuer: userPoolProviderUrl
          }
        )

        setClaims(payload)
      }
    } catch {
      // do nothing
    }
  }

  async function storeTokens (tokens, redirect) {
    authClient.storeTokens(tokens, redirect)
    const idToken = authClient.tokens?.idToken
    if (idToken && completedEmployeeInvitationsForToken !== idToken) {
      completedEmployeeInvitationsForToken = idToken
      completeEmployeeInvitations(authClient)
    }
    await fetchClaims()
  }

  function isLoggedIn () {
    return !!authClient.tokens?.idToken
  }

  function isExpired () {
    return isLoggedIn() && (!claims?.exp || (claims?.exp <= _.floor((_.now() / 1000))))
  }

  useEffect(() => {
    fetchClaims()
  }, [config])

  return {
    authClient,
    claims,
    storeTokens,
    isLoggedIn,
    isExpired
  }
}
